import { render, staticRenderFns } from "./miniappEntrance.vue?vue&type=template&id=80918eec&scoped=true"
import script from "./miniappEntrance.vue?vue&type=script&lang=js"
export * from "./miniappEntrance.vue?vue&type=script&lang=js"
import style0 from "./miniappEntrance.vue?vue&type=style&index=0&id=80918eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80918eec",
  null
  
)

export default component.exports